<template>
  <div class="e_app">
    <router-view></router-view>
  </div>
</template>
<script>
import "@/assets/css/index.css";
import "@/assets/js/jquery.min.js";

import '@/assets/js/swiper.min.js'
import '@/assets/css/swiper.min.css'
export default {};
</script>
<style>
.el-loading-mask {
  display: none !important;
}
.e_app{
  background-image: url('../assets/images/banner.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  overflow: hidden;
}
</style>